import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { GetMerchantPriceResponse } from "./getMerchantPrice.types";
import { requestGetMerchantPrice } from "./getMerchantPriceRequest";

const useGetMerchantPrice = (
  options?: QueryOptions<GetMerchantPriceResponse, ApiServiceError<ApiError>>
) => {
  const { data, isLoading, ...rest } = useQuery({
    queryKey: ["flex-data", "merchant-price"],
    queryFn: requestGetMerchantPrice,
    onError: toastServerError,
    ...options
  });

  return {
    merchantPrice: data?.value,
    isMerchantPriceLoading: isLoading,
    ...rest
  };
};

export default useGetMerchantPrice;
